import { ChangeDetectionStrategy, Component, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ItemsEmisionFacadeService } from './items-emision-facade.service';
import { CurrencyFormatPipe } from '../../../pipes/currency-format.pipe';
import { FieldErrorComponent } from '../../../shared/components/field-error/field-error.component';

@Component({
  selector: 'app-items-publinotas',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputNumberModule,
    InputTextModule,
    SelectModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    CurrencyFormatPipe,
    FieldErrorComponent
  ],
  templateUrl: './items-publinotas.component.html',
  styleUrls: ['./items-publinotas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemsPublinotasComponent {
  @Input() readOnly: boolean = false;
  pricingDialogVisible = false;
  selectedTrace: any = null;

  readonly items = computed(() => this.facade.itemsByType().PUBLINOTA || []);
  readonly bonificadoOptions = [
    { label: 'No', value: false },
    { label: 'Sí', value: true }
  ];

  constructor(public facade: ItemsEmisionFacadeService) {}

  trackByRowId(index: number, item: { group: FormGroup; index: number }): string | number {
    return item.group.get('clientRowId')?.value ?? item.group.get('id')?.value ?? index;
  }

  handleRowKeydown(event: KeyboardEvent, index: number): void {
    if ((event.ctrlKey || event.altKey) && event.key === 'Enter') {
      if (this.readOnly) {
        return;
      }
      event.preventDefault();
      this.facade.addItem('PUBLINOTA');
      this.focusTitulo(index + 1);
    }
  }

  handleEnterAdvance(event: Event, itemGroup: FormGroup, controlName: string): void {
    if (!(event instanceof KeyboardEvent) || event.key !== 'Enter') {
      return;
    }
    const control = itemGroup.get(controlName);
    if (control?.invalid) {
      return;
    }
    event.preventDefault();
    this.focusNextField(event);
  }

  confirmRemove(itemGroup: FormGroup, index: number): void {
    const shouldConfirm = this.facade.shouldConfirmDelete(itemGroup, 'PUBLINOTA');
    if (!shouldConfirm || window.confirm('¿Eliminar ítem de Publinotas?')) {
      this.facade.removeItem(index);
    }
  }

  openPricingDetail(itemGroup: FormGroup): void {
    this.selectedTrace = itemGroup.get('pricingTrace')?.value ?? null;
    this.pricingDialogVisible = true;
  }

  resetManualSubtotal(itemGroup: FormGroup): void {
    itemGroup.patchValue({ subtotalManual: null });
  }

  focusTitulo(index: number): void {
    setTimeout(() => {
      const input = document.getElementById(`publinota-item-titulo-${index}`);
      if (input) {
        input.focus();
      }
    }, 0);
  }

  private focusNextField(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;
    const row = target?.closest('.item-row');
    if (!row) {
      return;
    }
    const focusables = Array.from(row.querySelectorAll<HTMLElement>(
      'input,button,textarea,select,[tabindex]:not([tabindex="-1"])'
    ));
    const index = focusables.indexOf(target as HTMLElement);
    const next = focusables[index + 1];
    if (next) {
      next.focus();
    }
  }
}
